import React from "react";
import { es } from "@/locales/es";

export const SectionHeaderES = () => {
  const t = es.intro;
  return (
    <section
      id="section-meet-you-there-es"
      className="relative bg-cream w-full px-6 sm:px-10 lg:px-16 pt-28 sm:pt-36 lg:pt-40 pb-16 sm:pb-20"
      data-testid="section-header-es"
    >
      <div className="max-w-prose3 mx-auto">
        <h2
          className="display-serif text-nearblack text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-8 sm:mb-10"
          data-testid="section-header-headline-es"
        >
          {t.headline}
        </h2>
        <p
          className="font-body text-base sm:text-lg leading-relaxed text-nearblack/75 max-w-prose2"
          data-testid="section-header-subline-es"
        >
          {t.body}
        </p>
      </div>
    </section>
  );
};

export default SectionHeaderES;
